import React from 'react';

import classNames from 'classnames';
import { Link as RouterLink } from 'react-router';

import type { Path } from 'react-router';

export type GenericLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  to?: string | Partial<Path>;
};

export type LinkSize = 'lg' | 'md' | 'sm' | 'xs';

type Props = GenericLinkProps & {
  classNames?: string;
  disabled?: boolean;
};

export const GenericLink: React.FC<Props> = ({
  to,
  href,
  classNames,
  disabled,
  children,
  ...rest
}) => {
  if (disabled) {
    return (
      <span className={classNames} role="link" aria-disabled>
        {children}
      </span>
    );
  }

  return to ? (
    <RouterLink to={to} className={classNames} {...rest}>
      {children}
    </RouterLink>
  ) : (
    <a href={href} className={classNames} role="link" {...rest}>
      {children}
    </a>
  );
};

const linkStyleResetClassNames = 'no-underline text-primary hover:no-underline hover:text-primary';

export const UnstyledGenericLink: React.FC<Props> = ({ className, ...props }) => (
  <GenericLink className={classNames(linkStyleResetClassNames, className)} {...props} />
);
